module.exports = __webpack_public_path__ + "img/backIdCard.d77f4a2a.svg";